/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useContext} from 'react';
import {useStore} from '../../../../../../store/store';
import {observer} from 'mobx-react';
import {useForm, Controller} from 'react-hook-form';
import {toast} from 'react-toastify';
import {IMaskInput} from 'react-imask';
import {CreateAppModal} from '../../../../../../_metronic/partials';
import {Button} from '../../../../../shared/Buttons';
import Warning from '../../../../../modules/Warning';
import {Selector, SelectorIsMulti} from '../../../../../shared/Selectors';
import {TableWrapperContext} from '../../../../../table/new/TableWrapper';

const AddTarget = ({traffic_id}) => {
  const {presetData, activatePreset, objectToQueryString} = useContext(TableWrapperContext);
  const store = useStore();
  const {
    register,
    control,
    handleSubmit,
    formState: {errors},
    setValue,
    reset,
    watch,
  } = useForm();

  const [showCreateAppModal, setShowCreateAppModal] = useState(false);
  const [warning, setWarning] = useState(false);
  const [save, setSave] = useState(false);

  const [optionsBayers, setOptionsBayers] = useState([]);
  const [optionsBots, setOptionsBots] = useState([]);
  const [optionsChannels, setOptionsChannels] = useState([]);

  const [categoriesObj, setCategoriesObg] = useState([]);
  const [optionsCategories, setOptionsCategories] = useState([]);
  const [optionsStatus, setOptionStatus] = useState([]);

  const trafficCategory = watch('traffic_category_id');
  const trafficSubCategory = watch('traffic_subcategory_id');

  useEffect(() => {
    if (showCreateAppModal) {
      (async () => {
        const [getBots, getBayers, categories, statusList] = await Promise.all([
          store.requestGet('Bots/getListBots'),
          store.requestGet(`Traffics/Influence/getBayersList`),
          store.requestGet(`traffics/influence/categories`),
          store.requestGet(`traffics/influence/status/list`),
        ]);

        setCategoriesObg(categories);
        setOptionsCategories(categories.map((item) => ({value: item.id, label: item?.name})));
        setOptionStatus(
          statusList.map((status) => ({
            label: status.name,
            value: status.id,
          }))
        );
        setValue('status', 1);

        const newBots = getBots.map((el) => {
          return {label: el.name, value: el.id};
        });

        const newBayers = getBayers.map((el) => {
          return {label: `${el.first_name} ${el.last_name}`, value: el.id};
        });

        setOptionsBots(newBots);
        setOptionsBayers(newBayers);
        setValue('traffic_id', traffic_id);
        setValue('cost', '0');
        if (store.roles.includes(19) || store.roles.includes(20)) {
          setValue('bayer_id', store.user.id);
        }
      })();
    }
  }, [showCreateAppModal]);

  useEffect(() => {
    const subscription = watch((value, {name, type}) => {
      if (name === 'bot_id') {
        setOptionsChannels([]);
        getChannels(value.bot_id);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const getChannels = async (bot_id) => {
    const getChannels = await store.requestGet(`Channels/getChannelsList`, {
      params: {config: 'main', bot_id},
      preloader: false,
    });

    const newChannels = getChannels.map((el) => {
      return {label: el.name, value: el.id};
    });

    setOptionsChannels(newChannels);
  };

  const onSubmit = async (data) => {
    const result = await store.requestPost(`traffics/influence/source`, {
      data: {
        ...data,
        cost: Number(data.cost.replace(/\s/g, '')),
        channel_ids: data.channel_ids.map((item) => item.value),
      },
    });

    notify(!!result, !!result ? 'Успешно сохранено!' : 'Произошла ошибка!');

    activatePreset(objectToQueryString(presetData));
    reset();
    setSave(true);
    setShowCreateAppModal(false);
  };

  const notify = (action, message) => {
    if (!action) {
      toast.error(`${message}`, {
        theme: 'colored',
      });
    } else {
      toast.success(`${message}`, {});
    }
  };

  return (
    <>
      <Button action={() => setShowCreateAppModal(true)}>Создать</Button>
      <CreateAppModal
        customWidth='mw-550px'
        padding='scroll-y'
        show={showCreateAppModal}
        handleClose={() => {
          if (save) {
            setShowCreateAppModal(false);
          } else {
            setWarning(true);
          }
        }}
        title={'Добавить поток'}
      >
        <>
          <form
            // className='form fv-plugins-bootstrap5 fv-plugins-framework'
            style={{display: 'flex', flexDirection: 'column'}}
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className='fv-row mb-7 fv-plugins-icon-container'>
              <label className='required fw-semibold fs-6 mb-2'>Выберите категорию рекламы</label>

              <Controller
                name='traffic_category_id'
                control={control}
                rules={{required: true}}
                render={({field: {onChange, value, name, ref}}) => (
                  <Selector
                    options={optionsCategories}
                    value={value}
                    onChange={(e) => {
                      setValue('traffic_subcategory_id', '');
                      onChange(e);
                    }}
                  />
                )}
              />

              {errors?.traffic_category_id?.type === 'required' && (
                <div className='fs-6 fw-semibold form-label mb-2 text-danger'>
                  Обязательное поле
                </div>
              )}
            </div>
            {!!trafficCategory && (
              <div className='fv-row mb-7 fv-plugins-icon-container'>
                <label className='required fw-semibold fs-6 mb-2'>Выберите тип рекламы</label>

                <Controller
                  name='traffic_subcategory_id'
                  control={control}
                  rules={{required: true}}
                  render={({field: {onChange, value}}) => (
                    <Selector
                      options={
                        categoriesObj
                          .find((item) => item.id === trafficCategory)
                          ?.subcategories.map((item) => ({
                            value: item?.id,
                            label: item?.name,
                          })) || []
                      }
                      value={value ?? ''} // обовʼязково – передаємо id (або '' для очищення)
                      onChange={(val) => onChange(val)} // отримуємо id
                    />
                  )}
                />

                {errors?.traffic_subcategory_id?.type === 'required' && (
                  <div className='fs-6 fw-semibold form-label mb-2 text-danger'>
                    Обязательное поле
                  </div>
                )}
              </div>
            )}
            {store.roles.includes(19) || store.roles.includes(20) ? (
              <></>
            ) : (
              <div className='fv-row mb-7 fv-plugins-icon-container'>
                <label className='required fw-semibold fs-6 mb-2'>Выберите Байера</label>

                <Controller
                  name='bayer_id'
                  control={control}
                  rules={{required: true}}
                  render={({field: {onChange, value, name, ref}}) => (
                    <Selector options={optionsBayers} value={value} onChange={onChange} />
                  )}
                />

                {errors?.bayer_id?.type === 'required' && (
                  <div className='fs-6 fw-semibold form-label mb-2 text-danger'>
                    Обязательное поле
                  </div>
                )}
              </div>
            )}
            <div className='fv-row mb-7 fv-plugins-icon-container'>
              <label className='required fw-semibold fs-6 mb-2'>Выберите Бота</label>

              <Controller
                name='bot_id'
                control={control}
                rules={{required: true}}
                render={({field: {onChange, value, name, ref}}) => (
                  <Selector options={optionsBots} value={value} onChange={onChange} />
                )}
              />

              {errors?.bot_id?.type === 'required' && (
                <div className='fs-6 fw-semibold form-label mb-2 text-danger'>
                  Обязательное поле
                </div>
              )}
            </div>
            {optionsChannels.length > 0 && (
              <div
                className='fv-row mb-7 fv-plugins-icon-container'
                // style={{display: 'block', height: '100px'}}
              >
                <label className='required fw-semibold fs-6 mb-2'>Выберите Канал</label>
                <Controller
                  name='channel_ids'
                  control={control}
                  rules={{required: true}}
                  render={({field: {onChange, value, name, ref}}) => (
                    <SelectorIsMulti options={optionsChannels} value={value} onChange={onChange} />
                  )}
                />

                {errors?.channel_ids?.type === 'required' && (
                  <div className='fs-6 fw-semibold form-label mb-2 text-danger'>
                    Обязательное поле
                  </div>
                )}
              </div>
            )}
            <div className='fv-row mb-7 fv-plugins-icon-container'>
              <label className='required fw-semibold fs-6 mb-2'>Название</label>

              <input
                type='text'
                className='form-control form-control-solid mb-3 mb-lg-0'
                placeholder=''
                {...register('name', {required: true})}
              />

              {errors?.name?.type === 'required' && (
                <div className='fs-6 fw-semibold form-label mb-2 text-danger'>
                  Обязательное поле
                </div>
              )}
            </div>

            <div className='fv-row mb-7 fv-plugins-icon-container'>
              <label className='fw-semibold fs-6 mb-2'>Расходы</label>
              <Controller
                control={control}
                rules={{required: true}}
                name='cost'
                render={({field: {value, ref, ...fieldProps}}) => {
                  return (
                    <>
                      <IMaskInput
                        {...fieldProps}
                        inputRef={ref}
                        className='form-control form-control-lg form-control-solid'
                        // Маска з блоком для числа і фіксованим суфіксом
                        mask='num'
                        lazy={false} // показує суфікс одразу
                        unmask='typed' // повертає число в onAccept
                        inputMode='decimal' // мобільна клавіатура з крапкою
                        blocks={{
                          num: {
                            mask: Number,
                            scale: 2, // два знаки після крапки
                            radix: '.', // крапка як роздільник дробової частини
                            thousandsSeparator: ' ',
                            padFractionalZeros: true,
                            normalizeZeros: true,
                          },
                        }}
                      />
                    </>
                  );
                }}
              />
            </div>
            <div className='fv-row mb-7 fv-plugins-icon-container'>
              <label className='fw-semibold fs-6 mb-2'>Статус Рекламы</label>

              <Controller
                name='status'
                control={control}
                rules={{required: false}}
                render={({field: {onChange, value, name, ref}}) => (
                  <Selector options={optionsStatus} value={value} onChange={onChange} />
                )}
              />
            </div>
            <div className='fv-row mb-7 fv-plugins-icon-container'>
              <label className='fw-semibold fs-6 mb-2'>Ссылка на источник</label>

              <input
                type='text'
                className='form-control form-control-solid mb-3 mb-lg-0'
                placeholder=''
                {...register('source_link', {required: false})}
              />
            </div>
            <div className='d-flex flex-end pt-10'>
              <input
                type='submit'
                className={`btn fw-bold  btn-primary cursor-pointer `}
                value={'Сохранить'}
              />
            </div>
          </form>
          <CreateAppModal
            customWidth='mw-400px'
            padding='pb-lg-10 pt-lg-10 px-lg-10'
            show={warning}
            handleClose={() => setWarning(false)}
            showHeader={false}
            isMessage={true}
          >
            <Warning
              buttons={[
                {
                  action: () => {
                    setWarning(false);
                  },
                  title: <i className='bi bi-x p-0 fs-1'></i>,
                  class: 'btn-light',
                },
                {
                  action: () => {
                    setWarning(false);
                    setShowCreateAppModal(false);
                    reset();
                  },
                  title: <i className='bi bi-check p-0 fs-1'></i>,
                  class: 'btn-light-primary',
                },
              ]}
            />
          </CreateAppModal>
        </>
      </CreateAppModal>
    </>
  );
};

export default observer(AddTarget);
